exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#hamburger{display:-webkit-box;display:-ms-flexbox;display:flex}#hamburger #company{display:none}@media screen and (min-width: 768px){#hamburger #company{display:-webkit-box;display:-ms-flexbox;display:flex;padding-top:21px;font-size:13px}}@media screen and (min-width: 1280px){#hamburger #company{font-size:13px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/scss/component/topbarSidebarButton.scss
// module id = 1973
// module chunks = 3